export const WA_LINK = "/daddyhere";
export const LOGO = "/assets/logo.png";

export const NAV = [
  ["Home", "#home"], ["About Us", "#about"], ["How to Play", "#how-to-play"],
  ["Why Us", "#why-us"], ["Features", "#features"], ["FAQ", "#faq"],
];

export const WHY = [
  ["One of the Oldest in the Market with Real Players!", "Since 2015, we have worked hard to earn the trust of our customers. We launched our website, bringing us closer to our customers and providing our Cricket ID services 24×7."],
  ["Protected and Reliable Online Cricket ID", "Your data is never exposed. We offer secure access with absolute user privacy protection for every online betting ID and Cricket ID."],
  ["All Significant Cricket Matches Included", "IPL, World Cup and every domestic T20 league are included in your online Cricket ID, powered by a fast and dependable live API."],
  ["24/7 Customer Assistance", "We are available around the clock. If you face any problem with your online Cricket ID, reach out on WhatsApp and we resolve it promptly."],
];

export const FEATURES = [
  "Unlimited Sports & Casino", "100% Transparency and Security", "Cricket ID instantly within 2 minutes",
  "5% Welcome Bonus", "10% Loss Commission", "24/7 Customer Support",
  "Safe and Secure Transactions", "Fastest Withdrawal (10–15 minutes)",
];

export const STEPS = [
  ["/assets/step1.png", "Message on WhatsApp", "Tap any button and say hi to our Cricket ID team."],
  ["/assets/step2.png", "Share your details", "Tell us your name and preferred platform."],
  ["/assets/step3.png", "Deposit via UPI", "Start from ₹100 using UPI, Bank or USDT."],
  ["/assets/step4.png", "Get your Cricket ID", "Your verified online Cricket ID arrives in 2 minutes."],
];

export const FAQ = [
  ["How to get an Online Cricket ID?", "Connect with us on the website or via WhatsApp and our support team will share your Cricket ID as soon as possible. All services are available 24X7."],
  ["What do we offer?", "Unlike other providers, we treat our customers as top priority with bonuses and offers that suit you — cricket, football, tennis and 650+ casino games on one Cricket ID."],
  ["Where to get live updates?", "Once your ID is given by our customer care, simply log in and see all reports and live feeds directly in your dashboard with real-time odds."],
  ["Is support available 24X7?", "YES! Our dedicated team helps you 24X7 with fast responses for deposits, withdrawals and any Cricket ID query."],
  ["How to trust DaddyAnna?", "We have served under the registered name “DADDYANNA” since 2015. Some websites misuse our name — please only trust the original DaddyAnna site and our official WhatsApp."],
];
